import React from 'react';


const Header = () => {
  return <header className='py-8'>
    <div className='container mx-auto'>
      <div className='flex justify-between items-center'>
        <a href='https://manibhaskar.netlify.app/'>
          <h1
          className='text-accent text-[26px] lg:text-[30px] font-secondary font-semibold uppercase'
          wrapper='span'>
          MANI BHASKAR</h1>
        </a>

        <a href='https://nwizer.com/' target='_blank' rel='noopener noreferrer'>
            <button className='btn btn-sm'>Go To My Blogsite</button>
          </a>
      </div>
    </div>
  </header>;
};

export default Header;
